import { AxiosResponse } from "axios";
import API from "../api";
import { ShipmentShareLink } from "../models/shipments";
import { ShipmentsTracking } from "../models/shipments/shipments.tracking";

import BaseService from "./_base.service";

const endpoint = "/tracking/shipments";

export const ShipmentTrackingVersionService = {
  ...BaseService<ShipmentsTracking>({ endpoint }),
  async getInfo(options?: any): Promise<AxiosResponse<any>> {
    return await API.get(`${endpoint}/external`, { params: options });
  },
  async sendShareLink(data: ShipmentShareLink): Promise<AxiosResponse<boolean>> {
    return await API.post(`${endpoint}/share`, data);
  },
  async getDataToExport(params?: any): Promise<AxiosResponse<any[]>> {
    return await API.get(`${endpoint}/export`, { params });
  }
};
